import { FluidGrid } from '@design-system/fluid-grid';
import { PageBlock } from '@design-system/page-block';
import { Pagination } from '@design-system/pagination';
import { Typography } from '@design-system/typography';
import React, { forwardRef } from 'react';

import { usePagination } from '~/hooks/usePagination';

import { ItemListingCounterProps } from './models';

export const ItemListingCounter = forwardRef<
  HTMLDivElement,
  Omit<ItemListingCounterProps, 'type'>
>(
  (
    {
      pageBlock,
      fluidGrid,
      initialNumberArticles = 8,
      items,
      id,
      uid,
      pagination,
      itemsName,
      itemsAmount,
      filters,
    },
    ref
  ) => {
    const { visibleItems, page, setPage } = usePagination({
      items,
      itemsPerPage: initialNumberArticles,
    });

    const totalCount = items.length;
    const paginationProps = {
      onPageChange: setPage,
      currentPage: page,
      totalCount,
      pageSize: initialNumberArticles,
      ariaLabels: pagination,
    };

    return (
      <PageBlock
        {...pageBlock}
        className="item-listing-counter-block"
        id={id}
        componentUid={uid}
        ref={ref}
      >
        {totalCount ? (
          <>
            {filters ? (
              <div className="item-listing-counter-block__counter">
                <Typography
                  content={`${itemsName} (${itemsAmount})`}
                  variant="headline"
                />
              </div>
            ) : null}
            <FluidGrid {...fluidGrid}>{visibleItems}</FluidGrid>
            <Pagination {...paginationProps} />
          </>
        ) : null}
      </PageBlock>
    );
  }
);

export default ItemListingCounter;
